module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.33696c16.eot";